import {
  db,
  balliCollection,
  balaCollection,
  questionsCollection,
  userDataCollection,
  configurationCollection
} from "@/firebase";
import { runInNewContext } from "vm";
import { TTMJ } from "@/store/enums.ts";
import store from "./store";

export default {
  state: {
    radioHeaders: {},
    currentBalliTimepoint: null,
    numBalliQuestions: 0,
    balliRadioHeader: null,
    balliQuestionsLoaded: false,
    balliQuestions: {
      ability: [],
      abilityDone: false,
      attitude: [],
      attitudeDone: false,
      regulation: [],
      regulationDone: false,
      grit: [],
      gritDone: false
    },
    currentBalaTimepoint: null,
    numBalaQuestions: 11, // readingTask 1: 3, readingTask2: 4, readingTask3: , writingTask1: 1 // Needs to be updated
    balaPassages: {
      readingTask1: [],
      readingTask2: [],
      readingTask3: [],
      readingTask4: [],
      readingTask5: []
    },
    balaUnderstandingLoaded: false,
    balaUnderstanding: {
      readingTask1: [],
      readingTask1Done: false,
      readingTask2: [],
      readingTask2Done: false,
      readingTask3: [],
      readingTask3Done: false,
      readingTask4: [],
      readingTask4Done: false,
      readingTask5: [],
      readingTask5Done: false
    },
    balaQuestionsLoaded: false,
    balaQuestions: {
      readingTask1: [],
      readingTask1Done: false,
      readingTask2: [],
      readingTask2Done: false,
      readingTask3: [],
      readingTask3Done: false,
      readingTask4: [],
      readingTask4Done: false,
      readingTask5: [],
      readingTask5Done: false
    },
    balaWRatings: {
      writingTask1: [],
      writingTask1Header: null,
      writingTask1Done: false,
      writingTask1Loaded: false,
      writingTask2: [],
      writingTask2Header: null,
      writingTask2Done: false,
      writingTask2Loaded: false
    },
    balaWQuestions: {
      writingTask1: [],
      writingTask1Loaded: false,
      writingTask1Done: false,
      writingTask2: [],
      writingTask2Loaded: false,
      writingTask2Done: false
    },
    balaWResponse: {
      writingTask1: [],
      writingTask1Done: false,
      writingTask1Loaded: false,
      writingTask2: [],
      writingTask2Done: false,
      writingTask2Loaded: false
    },
    balaWPlanning: {
      writingTask1: [],
      writingTask1Done: false,
      writingTask1Loaded: false,
      writingTask2: [],
      writingTask2Done: false,
      writingTask2Loaded: false
    }
  },
  getters: {
    radioHeaders(state: any) {
      return state.radioHeaders;
    },
    balliQuestions(state: any) {
      return state.balliQuestions;
    },
    balliRadioHeader(state: any) {
      return state.balliRadioHeader;
    },
    balliQuestionsLoaded(state: any) {
      return state.balliQuestionsLoaded;
    },
    balaPassages(state: any) {
      return state.balaPassages;
    },
    balaUnderstanding(state: any) {
      return state.balaUnderstanding;
    },
    balaUnderstandingLoaded(state: any) {
      return state.balaUnderstandingLoaded;
    },
    balaQuestions(state: any) {
      return state.balaQuestions;
    },
    balaQuestionsLoaded(state: any) {
      return state.balaQuestionsLoaded;
    },
    balaWQuestions(state: any) {
      return state.balaWQuestions;
    },
    balaWRatings(state: any) {
      return state.balaWRatings;
    },
    balaWResponse(state: any) {
      return state.balaWResponse;
    },
    balaWPlanning(state: any) {
      return state.balaWPlanning;
    },
    numBalliQuestions(state: any) {
      return state.numBalliQuestions;
    },
    numBalaQuestions(state: any) {
      return state.numBalaQuestions;
    },
    balliTimepoint(state: any) {
      return state.currentBalliTimepoint;
    },
    balliTimepointStr(state: any) {
      return `timepoint${state.currentBalliTimepoint}`;
    },
    balaTimepoint(state: any) {
      return state.currentBalaTimepoint;
    },
    balaTimepointStr(state: any) {
      return `timepoint${state.currentBalaTimepoint}`;
    }
  },
  mutations: {
    addRadioHeader(state: any, header: any) {
      state.radioHeaders = header;
    },
    addBalliRadioHeader(state: any, header: number) {
      state.balliRadioHeader = header;
    },
    addAbilityQuestion(
      state: any,
      question: { Question: string; DefaultAnswer: number; qid: number }
    ) {
      state.balliQuestions.ability.push({
        question: question.Question,
        answer: question.DefaultAnswer,
        qid: question.qid
      });
      ++state.numBalliQuestions;
    },
    updateAbilityQuestion(
      state: any,
      question: { question: string; answer: number; qid: number }
    ) {
      var index = 0;
      var i = 0;

      // Find index of the question to modify
      while (i < state.balliQuestions.ability.length) {
        if (state.balliQuestions.ability[i].qid == question.qid) {
          index = i;
          break;
        }
        ++i;
      }

      if (i != state.balliQuestions.ability.length) {
        // Update answer
        state.balliQuestions.ability[i].answer = question.answer;
      } else {
        //console.log(question);
        //console.log("Error: Ability question not found; cannot update answer");
      }
    },
    abilityQuestionsChanged(
      state: any,
      answers: [{ question: string; answer: number }]
    ) {
      // Check if questions have changed since last response
      var changed = false;

      if (answers.length != state.balliQuestions.ability.length) {
        changed = true;
      } else {
        var i = 0;
        while (i < answers.length && !changed) {
          if (answers[i].question != state.balliQuestions.ability[i].question) {
            changed = true;
          }
          ++i;
        }
      }
      return changed;
    },
    MarkAbilityComplete(state: any) {
      // Mark this section as complete
      state.balliQuestions.abilityDone = true;
      //console.log(state.balliQuestions.abilityDone);
    },
    addAttitudeQuestion(
      state: any,
      question: { Question: string; DefaultAnswer: number; qid: number }
    ) {
      state.balliQuestions.attitude.push({
        question: question.Question,
        answer: question.DefaultAnswer,
        qid: question.qid
      });
      ++state.numBalliQuestions;
    },
    updateAttitudeQuestion(
      state: any,
      question: { question: string; answer: number; qid: number }
    ) {
      var index = 0;
      var i = 0;

      // Find index of the question to modify
      while (i < state.balliQuestions.attitude.length) {
        if (state.balliQuestions.attitude[i].qid == question.qid) {
          index = i;
          break;
        }
        ++i;
      }

      if (i != state.balliQuestions.attitude.length) {
        // Update answer
        state.balliQuestions.attitude[i].answer = question.answer;
      } else {
        //console.log(question);
        //console.log("Error: Attitude question not found; cannot update answer");
      }
    },
    attitudeQuestionsChanged(
      state: any,
      answers: [{ question: string; answer: number }]
    ) {
      // Check if questions have changed since last response
      var changed = false;

      if (answers.length != state.balliQuestions.attitude.length) {
        changed = true;
      } else {
        var i = 0;
        while (i < answers.length && !changed) {
          if (
            answers[i].question != state.balliQuestions.attitude[i].question
          ) {
            changed = true;
          }
          ++i;
        }
      }
      return changed;
    },
    markAttitudeComplete(state: any) {
      // Mark this section as complete
      state.balliQuestions.attitudeDone = true;
      //console.log(state.balliQuestions.attitudeDone);
    },
    addRegulationQuestion(
      state: any,
      question: { Question: string; DefaultAnswer: number; qid: number }
    ) {
      state.balliQuestions.regulation.push({
        question: question.Question,
        answer: question.DefaultAnswer,
        qid: question.qid
      });
      ++state.numBalliQuestions;
    },
    updateRegulationQuestion(
      state: any,
      question: { question: string; answer: number; qid: number }
    ) {
      var index = 0;
      var i = 0;

      // Find index of the question to modify
      while (i < state.balliQuestions.regulation.length) {
        if (state.balliQuestions.regulation[i].qid == question.qid) {
          index = i;
          break;
        }
        ++i;
      }

      if (i != state.balliQuestions.regulation.length) {
        // Update answer
        state.balliQuestions.regulation[i].answer = question.answer;
      } else {
        //console.log(question);
        //console.log(
        //  "Error: Regulation question not found; cannot update answer"
        //);
      }
    },
    regulationQuestionsChanged(
      state: any,
      answers: [{ question: string; answer: number }]
    ) {
      // Check if questions have changed since last response
      var changed = false;

      if (answers.length != state.balliQuestions.regulation.length) {
        changed = true;
      } else {
        var i = 0;
        while (i < answers.length && !changed) {
          if (
            answers[i].question != state.balliQuestions.regulation[i].question
          ) {
            changed = true;
          }
          ++i;
        }
      }
      return changed;
    },
    markRegulationComplete(state: any) {
      // Mark this section as complete
      state.balliQuestions.regulationDone = true;
      //console.log(state.balliQuestions.regulationDone);
    },
    addGritQuestion(
      state: any,
      question: { Question: string; DefaultAnswer: number; qid: number }
    ) {
      state.balliQuestions.grit.push({
        question: question.Question,
        answer: question.DefaultAnswer,
        qid: question.qid
      });
      ++state.numBalliQuestions;
    },
    updateGritQuestion(
      state: any,
      question: { question: string; answer: number; qid: number }
    ) {
      var index = 0;
      var i = 0;

      // Find index of the question to modify
      while (i < state.balliQuestions.grit.length) {
        if (state.balliQuestions.grit[i].qid == question.qid) {
          index = i;
          break;
        }
        ++i;
      }

      if (i != state.balliQuestions.grit.length) {
        // Update answer
        state.balliQuestions.grit[i].answer = question.answer;
      } else {
        //console.log(question);
        //console.log("Error: Grit question not found; cannot update answer");
      }
    },
    gritQuestionsChanged(
      state: any,
      answers: [{ question: string; answer: number }]
    ) {
      // Check if questions have changed since last response
      var changed = false;

      if (answers.length != state.balliQuestions.grit.length) {
        changed = true;
      } else {
        var i = 0;
        while (i < answers.length && !changed) {
          if (answers[i].question != state.balliQuestions.grit[i].question) {
            changed = true;
          }
          ++i;
        }
      }
      return changed;
    },
    markGritComplete(state: any) {
      // Mark this section as complete
      state.balliQuestions.gritDone = true;
      //console.log(state.balliQuestions.gritDone);
    },
    addBalaPassage1(state: any, passage: string) {
      state.balaPassages.readingTask1.push(passage);
      ++state.numBalaQuestions;
    },
    addBalaPassage2(state: any, passage: string) {
      state.balaPassages.readingTask2.push(passage);
      ++state.numBalaQuestions;
    },
    addBalaPassage3(state: any, passage: string) {
      state.balaPassages.readingTask3.push(passage);
      ++state.numBalaQuestions;
    },
    addBalaPassage4(state: any, passage: string) {
      state.balaPassages.readingTask4.push(passage);
      ++state.numBalaQuestions;
    },
    addBalaPassage5(state: any, passage: string) {
      state.balaPassages.readingTask5.push(passage);
      ++state.numBalaQuestions;
    },
    addBalaUnderstanding1(
      state: any,
      question: {
        question: string;
        answer: number;
        qid: number;
        header: string;
      }
    ) {
      state.balaUnderstanding.readingTask1.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid,
        header: question.header
      });
    },
    addBalaUnderstanding2(
      state: any,
      question: {
        question: string;
        answer: number;
        qid: number;
        header: string;
      }
    ) {
      state.balaUnderstanding.readingTask2.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid,
        header: question.header
      });
    },
    addBalaUnderstanding3(
      state: any,
      question: {
        question: string;
        answer: number;
        qid: number;
        header: string;
      }
    ) {
      state.balaUnderstanding.readingTask3.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid,
        header: question.header
      });
    },
    addBalaUnderstanding4(
      state: any,
      question: {
        question: string;
        answer: number;
        qid: number;
        header: string;
      }
    ) {
      state.balaUnderstanding.readingTask4.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid,
        header: question.header
      });
    },
    addBalaUnderstanding5(
      state: any,
      question: {
        question: string;
        answer: number;
        qid: number;
        header: string;
      }
    ) {
      state.balaUnderstanding.readingTask5.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid,
        header: question.header
      });
    },
    addBalaQuestion1(
      state: any,
      question: {
        question: string;
        responses: Array<string>;
        answer: number;
        qid: number;
      }
    ) {
      state.balaQuestions.readingTask1.push({
        question: question.question,
        responses: question.responses,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    addBalaQuestion2(
      state: any,
      question: {
        question: string;
        responses: Array<string>;
        answer: number;
        qid: number;
      }
    ) {
      state.balaQuestions.readingTask2.push({
        question: question.question,
        responses: question.responses,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    addBalaQuestion3(
      state: any,
      question: {
        question: string;
        responses: Array<string>;
        answer: number;
        qid: number;
      }
    ) {
      state.balaQuestions.readingTask3.push({
        question: question.question,
        responses: question.responses,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    addBalaQuestion4(
      state: any,
      question: {
        question: string;
        responses: Array<string>;
        answer: number;
        qid: number;
      }
    ) {
      state.balaQuestions.readingTask4.push({
        question: question.question,
        responses: question.responses,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    addBalaQuestion5(
      state: any,
      question: {
        question: string;
        responses: Array<string>;
        answer: number;
        qid: number;
      }
    ) {
      state.balaQuestions.readingTask5.push({
        question: question.question,
        responses: question.responses,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    addBalaWT1Ratings(
      state: any,
      question: { question: string; answer: boolean; qid: number }
    ) {
      state.balaWRatings.writingTask1.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    setBalaWT1RatingsHeader(state: any, header: number) {
      state.balaWRatings.writingTask1Header = header;
    },
    addBalaWT2Ratings(
      state: any,
      question: { question: string; answer: boolean; qid: number }
    ) {
      state.balaWRatings.writingTask2.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    setBalaWT2RatingsHeader(state: any, header: number) {
      state.balaWRatings.writingTask2Header = header;
    },
    addBalaWT1Questions(
      state: any,
      question: { question: string; answer: boolean; qid: number }
    ) {
      state.balaWQuestions.writingTask1.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    addBalaWT2Questions(
      state: any,
      question: { question: string; answer: boolean; qid: number }
    ) {
      state.balaWQuestions.writingTask2.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    addBalaWT1Response(
      state: any,
      question: { question: string; answer: boolean; qid: number }
    ) {
      state.balaWResponse.writingTask1.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    addBalaWT2Response(
      state: any,
      question: { question: string; answer: boolean; qid: number }
    ) {
      state.balaWResponse.writingTask2.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    addBalaWT1Planning(
      state: any,
      question: { question: string; answer: boolean; qid: number }
    ) {
      state.balaWPlanning.writingTask1.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    addBalaWT2Planning(
      state: any,
      question: { question: string; answer: boolean; qid: number }
    ) {
      state.balaWPlanning.writingTask2.push({
        question: question.question,
        answer: question.answer,
        qid: question.qid
      });
      ++state.numBalaQuestions;
    },
    updateBalaQuestions(
      state: any,
      p: {
        question: { question: string; answer: boolean; qid: number };
        task: number;
      }
    ) {
      let _task = state.balaQuestions[`readingTask${p.task}`];
      let i = 0;
      while (i < _task.length) {
        if (p.question.qid == _task[i].qid) break;
        i++;
      }
      if (i == _task.length) return;

      _task[i].question = p.question.question;
      _task[i].answer = p.question.answer;
    },
    updateBalaUnderstanding(
      state: any,
      p: {
        question: { question: string; answer: boolean; qid: number };
        task: number;
      }
    ) {
      let _task = state.balaUnderstanding[`readingTask${p.task}`];
      let i = 0;
      while (i < _task.length) {
        if (p.question.qid == _task[i].qid) break;
        i++;
      }
      if (i == _task.length) return;

      _task[i].question = p.question.question;
      _task[i].answer = p.question.answer;
    },
    updateBalaWQuestions(
      state: any,
      p: {
        question: { question: string; answer: boolean; qid: number };
        task: number;
      }
    ) {
      let _task = state.balaWQuestions[`writingTask${p.task}`];
      let i = 0;
      while (i < _task.length) {
        if (p.question.qid == _task[i].qid) break;
        i++;
      }
      if (i == _task.length) return;

      _task[i].question = p.question.question;
      _task[i].answer = p.question.answer;
    },
    updateBalaWPlanning(
      state: any,
      p: {
        question: { question: string; answer: boolean; qid: number };
        task: number;
      }
    ) {
      let _task = state.balaWPlanning[`writingTask${p.task}`];
      let i = 0;
      while (i < _task.length) {
        if (p.question.qid == _task[i].qid) break;
        i++;
      }
      if (i == _task.length) return;

      _task[i].question = p.question.question;
      _task[i].answer = p.question.answer;
    },
    updateBalaWResponse(
      state: any,
      p: {
        question: { question: string; answer: boolean; qid: number };
        task: number;
      }
    ) {
      let _task = state.balaWResponse[`writingTask${p.task}`];
      let i = 0;

      while (i < _task.length) {
        if (p.question.qid == _task[i].qid) break;
        i++;
      }
      if (i == _task.length) return;

      _task[i].question = p.question.question;
      _task[i].answer = p.question.answer;
    },
    updateBalaWRatings(
      state: any,
      p: {
        question: { question: string; answer: boolean; qid: number };
        task: number;
      }
    ) {
      let _task = state.balaWRatings[`writingTask${p.task}`];
      let i = 0;
      while (i < _task.length) {
        if (p.question.qid == _task[i].qid) break;
        i++;
      }
      if (i == _task.length) return;

      _task[i].question = p.question.question;
      _task[i].answer = p.question.answer;
    },
    setBalaWDataLoaded(state: any) {
      for (let i = 1; i <= 2; i++) {
        state[`balaWRatings`][`writingTask${i}Loaded`] = true;
        state[`balaWQuestions`][`writingTask${i}Loaded`] = true;
        state[`balaWResponse`][`writingTask${i}Loaded`] = true;
        state[`balaWPlanning`][`writingTask${i}Loaded`] = true;
      }
    },
    setBalliDataLoaded(state: any) {
      state.balliQuestionsLoaded = true;
    },
    setBalaQuestionsLoaded(state: any) {
      state.balaQuestionsLoaded = true;
    },
    setBalaUnderstandingLoaded(state: any) {
      state.balaUnderstandingLoaded = true;
    },
    updateTimepoint(
      state: any,
      p: {
        module: "Balli" | "Bala";
        currentTimepoint: number;
      }
    ) {
      state[`current${p.module}Timepoint`] = p.currentTimepoint;
    }
  },
  actions: {
    async loadLatestTimepoints({ commit }: any) {
      await configurationCollection
        .doc("timepoints")
        .get()
        .then(function(doc) {
          if (doc.exists) {
            let balli = doc.get("currentBalliTimepoint");
            let bala = doc.get("currentBalaTimepoint");
            // console.log(bala)
            commit("updateTimepoint", {
              module: "Balli",
              currentTimepoint: balli
            });
            commit("updateTimepoint", {
              module: "Bala",
              currentTimepoint: bala
            });
          }
        });
    },
    loadRadioHeaders({ commit }: any) {
      questionsCollection
        .doc("tableHeaders")
        .get()
        .then(function(doc) {
          if (doc.exists) {
            let headers = doc.get("headers");
            commit("addRadioHeader", headers);
          }
        });
    },
    loadBalliQuestions({ commit, state }: any) {
      var balliRef = questionsCollection.doc("balli");

      balliRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            // Load ability, attitude, regulation, and grit questions
            var sections = [
              {
                section: "AbilityQuestions",
                order: "AbilityOrder",
                commitFunction: "addAbilityQuestion"
              },
              {
                section: "AttitudeQuestions",
                order: "AttitudeOrder",
                commitFunction: "addAttitudeQuestion"
              },
              {
                section: "RegulationQuestions",
                order: "RegulationOrder",
                commitFunction: "addRegulationQuestion"
              },
              {
                section: "GritQuestions",
                order: "GritOrder",
                commitFunction: "addGritQuestion"
              }
            ];

            sections.forEach(function(sectionInfo, i) {
              var questions = doc.get(sectionInfo.section);
              if (questions != null) {
                let data: any = [];
                questions.forEach(function(question: {}) {
                  data.push(question);
                });
                doc.get(sectionInfo.order).forEach((index: number) => {
                  commit(sectionInfo.commitFunction, data[index]);
                });
              } else {
                //console.log("Error: Questions not found for ", sectionInfo.section);
              }
              if (i == 3) {
                commit("addBalliRadioHeader", doc.get("header"));
                commit("setBalliDataLoaded", {});
              }
            });
          } else {
            //console.log("Error: Balli questions not found");
          }
        })
        .catch(function(error) {
          //console.log("Error retriving Balli questions: ", error);
        });
    },
    loadBalaPassages({ commit }: any) {
      for (let i = 1; i <= 5; i++) {
        // Load reading task i section
        questionsCollection
          .doc("bala")
          .collection(`readingTask${i}`)
          .doc("passage")
          .get()
          .then(function(query) {
            query.get("Passage").forEach(function(item: string) {
              commit(`addBalaPassage${i}`, item);
            });
          })
          .catch(function(error) {
            //console.log("Error retriving Bala Reading Task 1 passages: ", error);
          });
      }
    },
    loadBalaUnderstanding({ commit }: any) {
      for (let i = 1; i <= 5; i++) {
        // Loading reading task i understanding questions
        questionsCollection
          .doc("bala")
          .collection(`readingTask${i}`)
          .doc("understanding")
          .get()
          .then(function(query) {
            query.get("Questions").forEach(function(item: any) {
              commit(`addBalaUnderstanding${i}`, {
                question: item.Question,
                answer: item.DefaultAnswer,
                qid: item.qid,
                header: item.header
              });
            });
          })
          .then(() => {
            if (i == 5) commit("setBalaUnderstandingLoaded", {});
          })
          .catch(function(error) {
            // console.log("Error retriving Bala Reading Task i understanding questions: ", error);
          });
      }
    },
    loadBalaQuestions({ commit }: any) {
      for (let i = 1; i <= 5; i++) {
        // Loading reading task i questions
        questionsCollection
          .doc("bala")
          .collection(`readingTask${i}`)
          .doc("questions")
          .get()
          .then(function(query) {
            let data: any = [];
            query.get("Questions").forEach(function(item: any) {
              data.push({
                question: item.Question,
                responses: item.Responses,
                answer: item.DefaultAnswer,
                qid: item.qid
              });
            });
            query.get("QuestionsOrder").forEach(function(index: any) {
              if (index < data.length)
                commit(`addBalaQuestion${i}`, data[index]);
            });
          })
          .then(() => {
            if (i == 5) commit("setBalaQuestionsLoaded", {});
          })
          .catch(function(error) {
            // console.log("Error retriving Bala Reading Task i understanding questions: ", error);
          });
      }
    },
    loadBalaWritingTask({ commit, state }: any) {
      let sections = [
        ["response", "Response"],
        ["planning", "Planning"],
        ["questions", "Questions"],
        ["rating", "Ratings"]
      ];

      sections.forEach(function(item) {
        for (let i = 1; i <= 2; i++) {
          // Loading writing task i questions
          questionsCollection
            .doc("bala")
            .collection(`writingTask${i}`)
            .doc(item[0])
            .get()
            .then(function(query) {
              if (query.exists) {
                let taskName = item[1];
                query.get("Questions").forEach(function(item: any) {
                  commit(`addBalaWT${i}${taskName}`, {
                    question: item.Question,
                    answer: item.DefaultAnswer,
                    qid: item.qid
                  });
                });
                if (taskName == "Ratings") {
                  let header = query.get("header");
                  commit(`setBalaWT${i}RatingsHeader`, header);
                  if (i == 2) {
                    commit("setBalaWDataLoaded", {});
                  }
                }
              }
            })
            .catch(function(error) {
              // console.log("Error retriving Bala Reading Task i understanding questions: ", error);
            });
        }
      });
    },
    loadBalliUserProgress({ commit, getters }: any, uid: string) {
      var sections = [
        {
          subsection: "ability",
          checker: "abilityQuestionsChanged",
          commit: "updateAbilityQuestion",
          complete: "markBalliComplete",
          progressName: "Ability"
        },
        {
          subsection: "attitude",
          checker: "attitudeQuestionsChanged",
          commit: "updateAttitudeQuestion",
          complete: "markBalliComplete",
          progressName: "Attitude"
        },
        {
          subsection: "regulation",
          checker: "regulationQuestionsChanged",
          commit: "updateRegulationQuestion",
          complete: "markBalliComplete",
          progressName: "Regulation"
        },
        {
          subsection: "grit",
          checker: "gritQuestionsChanged",
          commit: "updateGritQuestion",
          complete: "markBalliComplete",
          progressName: "Grit"
        }
      ];

      // set up completion status data
      userDataCollection
        .doc(uid)
        .collection("balli")
        .doc(getters.balliTimepointStr)
        .get()
        .then(function(doc) {
          if (!doc.exists || doc.get("completionStatus") === undefined) {
            let fields: any = { completionStatus: {} };
            sections.forEach((sub: { subsection: string }) => {
              fields["completionStatus"][sub.subsection] = {
                status: false,
                dateCompleted: null
              };
            });

            userDataCollection
              .doc(uid)
              .collection("balli")
              .doc(getters.balliTimepointStr)
              .set(fields)
              .then(function() {
                // alert("Document successfully written!");
              })
              .catch(function(error) {
                // alert(`Error writing document: ${error}`);
              });
          }
        });

      let atLeastOneComplete = false;
      // Load each section's answers, if they exist
      sections.forEach(function(sectionInfo) {
        var subsectionRef = userDataCollection
          .doc(uid)
          .collection("balli")
          .doc(getters.balliTimepointStr)
          .collection("responses")
          .doc(sectionInfo.subsection);

        subsectionRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              var userAnswers = doc.get("Answers");
              var changed = commit(sectionInfo.checker, userAnswers);

              if (atLeastOneComplete == false) {
                store.commit("markBalliComplete", "Intro");
                atLeastOneComplete = true;
              }
              // Update user progress
              if (!changed) {
                for (var i = 0; i < userAnswers.length; i++) {
                  commit(sectionInfo.commit, userAnswers[i]);
                }
                commit(sectionInfo.complete, sectionInfo.progressName);
                commit("progressBalli", userAnswers.length);
              }
            } else {
              //console.log(
              //  "No user progress found for Balli, subsection: ",
              //  sectionInfo.subsection
              //);
            }
          })
          .catch(function(error) {
            //console.log(
            //  "No user progress found for Balli, subsection: ",
            //  sectionInfo.subsection
            //);
            //console.log(error);
          });
      });
    },
    loadTTMJUserProgress({ commit, getters }: any, uid: string) {
      var sections = [
        {
          subsection: "patreason",
          complete: "markTTMJComplete",
          progressName: TTMJ.PATREASON
        },
        {
          subsection: "orf",
          complete: "markTTMJComplete",
          progressName: TTMJ.ORF
        },
        {
          subsection: "picture_story",
          complete: "markTTMJComplete",
          progressName: TTMJ.PICTURE
        },
        {
          subsection: "working_mem",
          complete: "markTTMJComplete",
          progressName: TTMJ.WORKMEM
        },
        {
          subsection: "ellison",
          complete: "markTTMJComplete",
          progressName: TTMJ.ELISON
        },
        {
          subsection: "story_retell",
          complete: "markTTMJComplete",
          progressName: TTMJ.STORY
        }
      ];

      // load each section's completion status:
      userDataCollection
        .doc(uid)
        .collection("ttmj")
        .doc("completionStatus")
        .get()
        .then(function(doc) {
          if (doc.exists) {
            sections.forEach(function(subsectionInfo) {
              let completionStatus = doc.get(subsectionInfo.progressName);
              if (completionStatus.status === true) {
                commit(subsectionInfo.complete, subsectionInfo.progressName);
              } else if (completionStatus.status == undefined) {
                // alert("undefined status: " + subsectionInfo.progressName);
              }
            });
          } else {
            let fields: any = {};
            sections.forEach((sub: { progressName: string }) => {
              fields[sub.progressName] = { status: false, dateCompleted: null };
            });

            userDataCollection
              .doc(uid)
              .collection("ttmj")
              .doc("completionStatus")
              .set(fields)
              .then(function() {
                // alert("Document successfully written!");
              })
              .catch(function(error) {
                // alert(`Error writing document: ${error}`);
              });
          }
        });
    },
    loadBalaUserProgress({ commit, getters }: any, uid: string) {
      var sections = [
        {
          subsection: "readingTask1",
          complete: "markBalaComplete",
          tasks: ["QuestionsAnswers", "UnderstandingAnswers"],
          commit: ["updateBalaQuestions", "updateBalaUnderstanding"],
          progressName: "Reading Task 1"
        },
        {
          subsection: "readingTask2",
          complete: "markBalaComplete",
          tasks: ["QuestionsAnswers", "UnderstandingAnswers"],
          commit: ["updateBalaQuestions", "updateBalaUnderstanding"],
          progressName: "Reading Task 2"
        },
        {
          subsection: "readingTask3",
          complete: "markBalaComplete",
          tasks: ["QuestionsAnswers", "UnderstandingAnswers"],
          commit: ["updateBalaQuestions", "updateBalaUnderstanding"],
          progressName: "Reading Task 3"
        },
        {
          subsection: "readingTask4",
          complete: "markBalaComplete",
          tasks: ["QuestionsAnswers", "UnderstandingAnswers"],
          commit: ["updateBalaQuestions", "updateBalaUnderstanding"],
          progressName: "Reading Task 4"
        },
        {
          subsection: "readingTask5",
          complete: "markBalaComplete",
          tasks: ["QuestionsAnswers", "UnderstandingAnswers"],
          commit: ["updateBalaQuestions", "updateBalaUnderstanding"],
          progressName: "Reading Task 5"
        },
        {
          subsection: "writingTask1",
          complete: "markBalaComplete",
          tasks: [
            "QuestionsAnswers",
            "PlanningAnswers",
            "ResponseAnswers",
            "RatingAnswers"
          ],
          commit: [
            "updateBalaWQuestions",
            "updateBalaWPlanning",
            "updateBalaWResponse",
            "updateBalaWRatings"
          ],
          progressName: "Writing Task 1"
        },
        {
          subsection: "writingTask2",
          complete: "markBalaComplete",
          tasks: [
            "QuestionsAnswers",
            "PlanningAnswers",
            "ResponseAnswers",
            "RatingAnswers"
          ],
          commit: [
            "updateBalaWQuestions",
            "updateBalaWPlanning",
            "updateBalaWResponse",
            "updateBalaWRatings"
          ],
          progressName: "Writing Task 2"
        }
      ];

      let completionStatus = function() {
        userDataCollection
          .doc(uid)
          .collection("bala")
          .doc(getters.balaTimepointStr)
          .get()
          .then(function(doc) {
            if (doc.exists && doc.get("completionStatus")) {
              let c = doc.get("completionStatus");
              sections.forEach(function(sec) {
                let sectionStatus = c[sec.subsection];
                if (sectionStatus == undefined) return;
                if (
                  sec.subsection == "writingTask1" ||
                  sec.subsection == "writingTask2"
                ) {
                  let responseStatus = sectionStatus["response"].status;
                  let ratingStatus = sectionStatus["rating"].status;
                  let questionStatus = sectionStatus["question"].status;
                  let planningStatus = sectionStatus["planning"].status;
                  if (responseStatus) {
                    store.dispatch("updateBalaProgress", {
                      section: sec.progressName,
                      subsection: "Response"
                    });
                  }
                  if (ratingStatus) {
                    store.dispatch("updateBalaProgress", {
                      section: sec.progressName,
                      subsection: "Rating"
                    });
                  }
                  if (questionStatus) {
                    store.dispatch("updateBalaProgress", {
                      section: sec.progressName,
                      subsection: "Question"
                    });

                    if (sec.subsection == "writingTask1") {
                      store.dispatch("updateBalaProgress", {
                        section: "Writing Task",
                        subsection: "Intro"
                      });
                    }
                  }
                  if (planningStatus) {
                    store.dispatch("updateBalaProgress", {
                      section: sec.progressName,
                      subsection: "Planning"
                    });
                  }
                } else {
                  let questionStatus = sectionStatus["questions"].status;
                  let understandingStatus =
                    sectionStatus["understanding"].status;
                  if (questionStatus) {
                    store.dispatch("updateBalaProgress", {
                      section: sec.progressName,
                      subsection: "Questions"
                    });
                  }
                  if (understandingStatus) {
                    store.dispatch("updateBalaProgress", {
                      section: sec.progressName,
                      subsection: "Understanding"
                    });

                    if (sec.subsection == "readingTask1") {
                      store.dispatch("updateBalaProgress", {
                        section: "Reading Task",
                        subsection: "Intro"
                      });
                    }
                  }
                }
              });
            } else {
              let fields: any = { completionStatus: {} };
              sections.forEach((sub: { subsection: string }) => {
                let taskMAP: any = {
                  writing: ["response", "rating", "planning", "question"],
                  reading: ["questions", "understanding"]
                };
                let task = "reading";
                if (
                  sub.subsection == "writingTask1" ||
                  sub.subsection == "writingTask2"
                ) {
                  task = "writing";
                }
                fields["completionStatus"][sub.subsection] = {};
                taskMAP[task].forEach((item: string) => {
                  fields["completionStatus"][sub.subsection][item] = {
                    status: false,
                    dateCompleted: null
                  };
                });
              });
              userDataCollection
                .doc(uid)
                .collection("bala")
                .doc(getters.balaTimepointStr)
                .set(fields)
                .then(function() {
                  // alert("Document successfully written!");
                })
                .catch(function(error) {
                  // alert(`Error writing document: ${error}`);
                });
            }
          });
      };

      completionStatus();

      // Load each section's answers, if they exist
      sections.forEach(function(sectionInfo) {
        sectionInfo.tasks.forEach(function(task, index) {
          var subsectionRef = userDataCollection
            .doc(uid)
            .collection("bala")
            .doc(getters.balaTimepointStr)
            .collection("responses")
            .doc(sectionInfo.subsection);

          let taskNumber =
            sectionInfo.subsection[sectionInfo.subsection.length - 1];
          subsectionRef
            .get()
            .then(function(doc) {
              if (doc.exists) {
                var userAnswers = doc.get(task);
                // Update user progress
                for (var i = 0; i < userAnswers.length; i++) {
                  //console.log(userAnswers[i]);
                  commit(sectionInfo.commit[index], {
                    question: userAnswers[i],
                    task: taskNumber
                  });
                }
                commit(sectionInfo.complete, sectionInfo.progressName);
                commit("progressBala", userAnswers.length);
              } else {
                //console.log(
                //  "No user progress found for Bala, subsection: ",
                //  sectionInfo.subsection
                //);
              }
            })
            .catch(function(error) {
              //console.log(
              //  "No user progress found for Bala, subsection: ",
              //  sectionInfo.subsection
              //);
              //console.log(error);
            });
        });
      });
    } //
  }
};
